goog.provide("shadow.js.shim.module$src$svg$artwork$folder_svg$default");
shadow.js.shim.module$src$svg$artwork$folder_svg$default = shadow.js.shim.module$src$svg$artwork$folder_svg.default;
